import { useSelector } from 'react-redux'
import { builderTypeSelector } from 'apps/formsCreationKit/store/selectors/workspaceConfig'
import { lib } from '@gocanvas/client'
const {
  SINGLE_CHOICE_DROPDOWN_STYLE,
  SINGLE_CHOICE_EDITABLE_DROPDOWN_STYLE,
  SINGLE_CHOICE_NOT_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
  SINGLE_CHOICE_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
  SINGLE_CHOICE_DROPDOWN_STYLES,
} = lib

const EditableToggle = {
  label: 'User Editable',
  settingType: 'toggleInput',
  updateType: 'entry',
  property: 'style',
  tooltipContent:
    'Choices added this way will not appear for other users or in future Submissions (unless added again manually).',
  dynamicChoices: ({ style }) => {
    return style == SINGLE_CHOICE_DROPDOWN_STYLE ||
      style == SINGLE_CHOICE_EDITABLE_DROPDOWN_STYLE
      ? [
          {
            value: SINGLE_CHOICE_EDITABLE_DROPDOWN_STYLE,
            previousValue: SINGLE_CHOICE_DROPDOWN_STYLE,
          },
          {
            value: SINGLE_CHOICE_DROPDOWN_STYLE,
            previousValue: SINGLE_CHOICE_EDITABLE_DROPDOWN_STYLE,
          },
        ]
      : [
          {
            value: SINGLE_CHOICE_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
            previousValue: SINGLE_CHOICE_NOT_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
          },
          {
            value: SINGLE_CHOICE_NOT_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
            previousValue: SINGLE_CHOICE_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
          },
        ]
  },
  showInput: ({ style }) => {
    const builderType = useSelector(builderTypeSelector)
    return (
      SINGLE_CHOICE_DROPDOWN_STYLES.includes(parseInt(style, 10)) &&
      ['builder', 'easy-form', 'studio'].includes(builderType)
    )
  },
}

const ShowDuplicatesToggle = {
  label: 'Show Duplicates',
  settingType: 'toggleInput',
  updateType: 'entry',
  property: 'style',
  tooltipContent:
    'If your Reference Column contains duplicate values you can elect to show them in your Drop Down choices.',
  dynamicChoices: ({ style }) => {
    return style == SINGLE_CHOICE_DROPDOWN_STYLE ||
      style == SINGLE_CHOICE_NOT_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE
      ? [
          {
            value: SINGLE_CHOICE_NOT_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
            previousValue: SINGLE_CHOICE_DROPDOWN_STYLE,
          },
          {
            value: SINGLE_CHOICE_DROPDOWN_STYLE,
            previousValue: SINGLE_CHOICE_NOT_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
          },
        ]
      : [
          {
            value: SINGLE_CHOICE_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
            previousValue: SINGLE_CHOICE_EDITABLE_DROPDOWN_STYLE,
          },
          {
            value: SINGLE_CHOICE_EDITABLE_DROPDOWN_STYLE,
            previousValue: SINGLE_CHOICE_EDITABLE_SHOW_DUPS_DROPDOWN_STYLE,
          },
        ]
  },
  showInput: ({ style, reference_data_id, data_source_context_id }) => {
    const builderType = useSelector(builderTypeSelector)
    const hasReferenceData = reference_data_id || data_source_context_id
    return (
      SINGLE_CHOICE_DROPDOWN_STYLES.includes(parseInt(style, 10)) &&
      ['builder', 'easy-form', 'studio'].includes(builderType) &&
      hasReferenceData
    )
  },
}

export const DropdownChoicesSettings = [EditableToggle, ShowDuplicatesToggle]
